"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.titleTextPropType = exports.pricePropType = exports.optionPropType = exports.linkPropType = exports.includedTextPropType = exports.imagePropType = exports.filterPropType = exports.dataPropType = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var imagePropType = _propTypes["default"].shape({
  image: _propTypes["default"].string,
  altText: _propTypes["default"].string
});

exports.imagePropType = imagePropType;

var pricePropType = _propTypes["default"].shape({
  label: _propTypes["default"].string,
  value: _propTypes["default"].number,
  displayValue: _propTypes["default"].string
});

exports.pricePropType = pricePropType;

var titleTextPropType = _propTypes["default"].shape({
  title: _propTypes["default"].string,
  text: _propTypes["default"].string
});

exports.titleTextPropType = titleTextPropType;

var linkPropType = _propTypes["default"].shape({
  URL: _propTypes["default"].string,
  label: _propTypes["default"].string,
  openNewTab: _propTypes["default"].bool
});

exports.linkPropType = linkPropType;

var includedTextPropType = _propTypes["default"].shape({
  id: _propTypes["default"].string,
  type: _propTypes["default"].string,
  label: _propTypes["default"].string,
  titleAndText: titleTextPropType,
  image: imagePropType,
  link: linkPropType
});

exports.includedTextPropType = includedTextPropType;

var optionPropType = _propTypes["default"].shape({
  id: _propTypes["default"].string,
  type: _propTypes["default"].string,
  code: _propTypes["default"].string,
  label: _propTypes["default"].string,
  image: imagePropType,
  price: pricePropType,
  includedOptions: _propTypes["default"].arrayOf(includedTextPropType),
  titleAndText: titleTextPropType,
  selected: _propTypes["default"].bool
});

exports.optionPropType = optionPropType;

var filterPropType = _propTypes["default"].shape({
  code: _propTypes["default"].string,
  label: _propTypes["default"].string,
  filteringOptions: _propTypes["default"].arrayOf(optionPropType)
});

exports.filterPropType = filterPropType;

var dataPropType = _propTypes["default"].shape({
  resourceType: _propTypes["default"].string,
  label: _propTypes["default"].string,
  filter: filterPropType,
  titleAndText: titleTextPropType
});

exports.dataPropType = dataPropType;